import { useEffect, useMemo, useState } from "react";
import { getEvents, searchEventsDebounced } from "../../functions/api";
import Advertisement from '../../components/Advertisement';
import { Link } from "react-router-dom";
import { Button, Checkbox, Collapse, Divider, IconButton, makeStyles } from "@material-ui/core";
import Popover from "../../components/Popover";
import CloseIcon from '@material-ui/icons/Close';
import { animateScroll as scroll } from 'react-scroll';
import { Tune } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { Alert, AlertTitle } from "@material-ui/lab";
import Autosuggest from "react-autosuggest";
import { defaultTheme } from 'react-autosuggest/dist/theme'
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { createFiltersQueryString } from "../../functions/functions";
const useStyle = makeStyles({
  suggestionsContainer: {
      maxHeight: '230px',
      overflowY: 'auto',
      backgroundColor: 'white'
  }
});
const searchAPIDebounced = AwesomeDebouncePromise(searchEventsDebounced, 500);

export default function Events() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const theme = useStyle()
  const [allEvents, setAllEvents] = useState([]);
  const [events, setEvents] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [cities, setCities] = useState(null);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchCarnivals, setSearchCarnivals] = useState([]);
  const [filterTypes, setFilterTypes] = useState(urlSearchParams.get('types') || []);
  const [isPast, setIsPast] = useState(urlSearchParams.get('isPast') || false);
  const [search, setSearch] = useState(
    {
      id: '',
      type: '',
    }
  );

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  }

  async function onSuggestionsFetchRequested({ value }) {
    if (value.length < 3) {
      setSearchCarnivals([{ name: "Please enter at least 3 characters" }]);
      return;
    }
    let find = await searchAPIDebounced(value);
    var data = [
      ...find.data?.festivalDates?.map((festival) => {
        return { ...festival._id, type: "festival" };
      }),
      ...find.data?.cities?.map((city) => {
        return { id: city._id, name: city.name, type: "city" };
      }),
    ];
    if (!data[0]) data = [{ name: "The filter returned no results" }];
    setSearchCarnivals(data);
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  function onSuggestionsClearRequested(val) {
    setSearchCarnivals([]);
  }
  function getSuggestionValue(item) {
    return item.name;
  }
  function onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    setSearchQuery(suggestion.name);
    setSearch({ id: suggestion.id, type: suggestion.type });
  }

  function renderSuggestion(item) {
    return <div>{item && item.name}</div>;
  }
  const inputProps = {
    placeholder: "Search carnivals/cities",
    value: searchQuery,
    onChange: handleSearch,
  };
  const history=useHistory()
  useEffect(function () {
    gererateSearchQuery();
    loadEvents();
    scroll.scrollToTop();
  }, [isPast, search]);
  const [alert, setAlert] = useState({
    serverity: "",
    title: "",
    message: "",
    open: false
  });

  const handlePastEvents = () => {
    setIsPast(!isPast);
  }

  const loadEvents = async () => {
    if (history.state?.code === 201) {
      setAlert({ ...alert, open: true, message: 'New event successfuly saved!', serverity: 'success', title: 'Success' });
    }
    let types = urlSearchParams.get('types');
    const data = await getEvents({ isPast, ...search });
    if(types) types= types.split(',')
    setFilterTypes(types || [])
    if (data && data.events) {
      setAllEvents(data && data.events);
      if (types && types[0]) {
        let newEvents = [];
        for (let event of data.events) {
          let common = event.types.filter(type => types.includes(type));
          if (common[0]) newEvents.push(event);
        }
        setEvents(newEvents);
      } else {
        setEvents(data.events);
      }
      setCities(data && data.cities);
      setEventTypes(data && data.eventTypes);
    }
  }
  const gererateSearchQuery = () => {
    const q = createFiltersQueryString({ types: filterTypes, isPast, searchQuery });
    history.push({
      search: q,
    });
  }

  const filterByType=async (ev,check)=>{
    var type=ev.target.value
    var newFilters=filterTypes
    // var data=allEvents
    if(!Array.isArray(newFilters)) newFilters=[newFilters]
    if(check) {
      newFilters.push(type)
      setFilterTypes(newFilters)
    }
    if(!check){
      newFilters=newFilters.filter((f)=>f!=type)
      setFilterTypes(newFilters)
    }

    if (newFilters && newFilters[0]) {
      let newEvents = [];
      for (let event of allEvents) {
        let common = event.types.filter(type => newFilters.includes(type));
        if (common[0]) newEvents.push(event);
      }
      setEvents(newEvents);
    } else {
      setEvents(allEvents);
    }
    gererateSearchQuery();
  }

  const filtersContent = (
    <div className="m-4">
      <h6>Search Events</h6>
      <div className="row">
      <div className="col-xl-12 col-sm-6 d-flex flex-column my-3 justify-content-center">
        <Autosuggest
            suggestions={searchCarnivals}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            onSuggestionSelected={onSuggestionSelected}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
            theme={{...defaultTheme, suggestionsContainer: theme.suggestionsContainer}}
        />
      </div>
      {eventTypes && Array.isArray(eventTypes) && eventTypes.map((ty)=>{
        return(
          <div className="col-md-3 col-sm-6" style={{whiteSpace: "nowrap"}} key={ty}>
          <Checkbox key={ty} value={ty} checked={(filterTypes?.[0] && filterTypes.includes(ty)) ? true : false} onChange={filterByType} id={ty.replaceAll(' ','_')}></Checkbox>
          {ty}
          </div>
        )
        }) }
      </div>
    </div>
  );
  const node1Ad = useMemo(() => <Advertisement node={1} page="festival" />, []);
  const node2Ad = useMemo(() => <Advertisement node={2} page="festival" />, []);
  const node9Ad = useMemo(() => <Advertisement node={9} page="festival" />, []);
  return (
    <div className="container mb-2">
      <h1 className="my-4 font-weight-bold">Carnival Events and Fetes</h1>
      {node1Ad}
      <Collapse className="mb-5" in={alert.open}>
          <Alert severity={alert.serverity} action={
              <IconButton aria-label="close" color="inherit" size="small"
                  onClick={() => setAlert({ ...alert, open: !alert.open })}>
                  <CloseIcon fontSize="inherit" />
              </IconButton>
          }>
              <AlertTitle>{alert.title}</AlertTitle>
              {alert.message}
          </Alert>
      </Collapse>
      <Divider flexItem={alert.open} />
      <div className="d-flex justify-content-between">
        {cities && Array.isArray(cities) &&
        <>
          <Popover handleOpen={() => setFiltersOpen(true)} handleClose={() => setFiltersOpen(false)} open={filtersOpen}
            id="filters" item={<span><Tune fontSize="inherit" />&nbsp;Filters</span>} content={filtersContent} />
        </>
        }

        <Button variant="outlined" color="default" onClick={handlePastEvents} className="my-3">{isPast ? 'All' : 'Past'} Events</Button>
        <Link to="/event/form">
          <Button className="my-3" variant="outlined" color="default">Add Event - Free</Button>
        </Link>
      </div>
      <ul className="list-group list-group-flush">
        {Array.isArray(events) && events.length > 0 ? events.map(event => (
          <li key={event._id} className="px-0 list-group-item d-flex justify-content-between text-capitalize">
            <Link to={`/events/${event.slug}`}>
              <h4 className="titleText font-weight-bold mb-0">{event.name}{event.price && ` - $${event.price}USD`}</h4>
              <b>{event.sDate}{event.vName && ` @ ${event.vName}`}{event.city && ` - ${event.city.name}`}</b>
            </Link>
            <div>
              {event.link && <a href={event.link} className="btn btn-primary btn-sm">Buy Tix</a>}
            </div>
          </li>
        )) : <h4 className="mt-4">No event found...</h4>}
      </ul>
      {node2Ad}
      {node9Ad}
    </div>
  )
}